/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_NewInputs */

const cs_requirements_new = /** @type {(inputs: Requirements_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová poptávka`)
};

const en_requirements_new = /** @type {(inputs: Requirements_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New demand`)
};

/**
* | output |
* | --- |
* | "New demand" |
*
* @param {Requirements_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_new = /** @type {((inputs?: Requirements_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_new(inputs)
	return cs_requirements_new(inputs)
});